export const isDefaultTableEditHydrated = ({
  formAction,
  recordHydrated,
  descriptorReady,
  optionsLoaded,
  mappingsReady,
  rowsReady,
  pricingReady,
  currencyReady,
  taxReady,
  summaryReady,
}) => {
  if (String(formAction || "").toUpperCase() !== "EDIT") return true;

  return [
    recordHydrated,
    descriptorReady,
    optionsLoaded,
    mappingsReady,
    rowsReady,
    pricingReady,
    currencyReady,
    taxReady,
    summaryReady,
  ].every(value => value === true);
};
